import React from "react";
import { connect } from "react-redux";
import objectPath from "object-path";
import { Link } from "react-router-dom";
import AnimateLoading from "../../../app/partials/layout/AnimateLoading";
import Notificacoes from "../../../app/partials/layout/Notificacoes";
import UserProfile from "../../../app/partials/layout/UserProfile";
import KTHeader from "../../_assets/js/header";
import * as builder from "../../ducks/builder";
import styles from "../../../app/styles/Header.module.scss";
import { toAbsoluteUrl } from "../../utils/utils";

class Header extends React.Component {
  headerCommonRef = React.createRef();

  componentDidMount() {
    const options = {};
    if (
      this.headerCommonRef.current.getAttribute("data-ktheader-minimize") === "1"
    ) {
      options["minimize.desktop.on"] = "kt-header--minimize";
      options["offset.desktop"] = 130;
    }

    new KTHeader(this.headerCommonRef.current, options);
  }

  render() {
    const { headerAttributes, headerClasses } = this.props;

    return (
      <div
        className={`kt-header kt-grid__item ${headerClasses} desk`}
        id="kt_header"
        ref={this.headerCommonRef}
        {...headerAttributes}
      >
        <div className={styles.navigationBar}>
          <div className={styles.logo}>
            <Link to="/">
              <img alt="logo" src={toAbsoluteUrl("/images/logo-white.png")} style={{ height: "24px"}} />
            </Link>
          </div>
          <div className={styles.tabNavBar}>
            <div className={styles.notification}>
              <Notificacoes />
            </div>
            <div className={styles.divider} />
            <div className={styles.profileFrame}>
              <UserProfile />
            </div>
          </div>
        </div>
        <AnimateLoading />
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  headerClasses: builder.selectors.getClasses(store, {
    path: "header",
    toString: true
  }),
  headerAttributes: builder.selectors.getAttributes(store, { path: "header" }),
  menuHeaderDisplay: objectPath.get(
    store.builder.layoutConfig,
    "header.menu.self.display"
  ),
  fluid:
    objectPath.get(store.builder.layoutConfig, "header.self.width") === "fluid"
});

export default connect(mapStateToProps)(Header);
